module.exports = __webpack_public_path__ + "static/case-study1-98526473e80aa4f143dfb9390f70cdf7.jpg";